/**
 * Icon mapping from scite icon names to Central icons
 *
 * All icons import from @central-icons-react/round-outlined-radius-1-stroke-1.5
 */

import { IconBubbleDots } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBubbleDots'
import { IconTrashCan } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconTrashCan'
import { IconPencil } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPencil'
import { IconShareOs } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconShareOs'
import { IconClipboard2 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconClipboard2'
import { IconFileDownload } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconFileDownload'
import { IconMagnifyingGlass } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconMagnifyingGlass'
import { IconPlusLarge } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPlusLarge'
import { IconMinusLarge } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconMinusLarge'
import { IconCrossMedium } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCrossMedium'
import { IconCheckmark1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCheckmark1'
import { IconSquareArrowTopRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSquareArrowTopRight'
import { IconCircleQuestionmark } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCircleQuestionmark'
import { IconCircleInfo } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCircleInfo'
import { IconExclamationTriangle } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconExclamationTriangle'
import { IconSettingsGear2 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSettingsGear2'
import { IconSparkle } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSparkle'
import { IconChevronRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChevronRight'
import { IconChevronLeft } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChevronLeft'
import { IconChevronBottom } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChevronBottom'
import { IconChevronTop } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChevronTop'
import { IconMinimize45 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconMinimize45'
import { IconExpand45 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconExpand45'
import { IconDotGrid1x3Vertical } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconDotGrid1x3Vertical'
import { IconDotGrid1x3Horizontal } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconDotGrid1x3Horizontal'
import { IconBookmark } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBookmark'
import { IconBookmarkCheck } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBookmarkCheck'
import { IconHistory } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconHistory'
import { IconFolder1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconFolder1'
import { IconEyeOpen } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconEyeOpen'
import { IconEyeSlash } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconEyeSlash'
import { IconTag } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconTag'
import { IconBell } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBell'
import { IconLightBulb } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconLightBulb'
import { IconSquareChecklistMagnifyingGlass } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSquareChecklistMagnifyingGlass'
import { IconLayoutDashboard } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconLayoutDashboard'
import { IconSidebar } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSidebar'
import { IconSidebarLeftArrow } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconSidebarLeftArrow'
import { IconArrowRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowRight'
import { IconArrowLeft } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowLeft'
import { IconArrowUp } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowUp'
import { IconArrowRightCircle } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowRightCircle'
import { IconLock } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconLock'
import { IconCircleCheck } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCircleCheck'
import { IconCircleX } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCircleX'
import { IconCirclePlus } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCirclePlus'
import { IconExclamationCircle } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconExclamationCircle'
import { IconFlag1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconFlag1'
import { IconVolumeUp } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconVolumeUp'
import { IconMagicWand } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconMagicWand'
import { IconBubble2 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBubble2'
import { IconChainLink1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconChainLink1'
import { IconFilter1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconFilter1'
import { IconColumns3 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconColumns3'
import { IconArrowUpRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowUpRight'
import { IconArrowBoxRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowBoxRight'
import { IconArrowShareRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowShareRight'
import { IconArrowWallRight } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowWallRight'
import { IconArrowRotateClockwise } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconArrowRotateClockwise'
import { IconLayoutGrid2 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconLayoutGrid2'
import { IconBulletList } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBulletList'
import { IconZap } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconZap'
import { IconReadingList } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconReadingList'
import { IconDeepSearch } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconDeepSearch'
import { IconCalendarClock } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCalendarClock'
import { IconTelescope } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconTelescope'
import { IconBubblePlus } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBubblePlus'
import { IconGlobe2 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconGlobe2'
import { IconPageTextSearch } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPageTextSearch'
import { IconShieldCheck } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconShieldCheck'
import { IconPeople } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPeople'
import { IconTable } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconTable'
import { IconCursorClick } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCursorClick'
import { IconWindowCursor } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconWindowCursor'
import { IconApiConnection } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconApiConnection'
import { IconBrowserTabs } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBrowserTabs'
import { IconCurrencyDollar } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconCurrencyDollar'
import { IconOrganisation } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconOrganisation'
import { IconBook } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconBook'
import { IconPageText } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPageText'
import { IconUser } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconUser'
import { IconTrending1 } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconTrending1'
import { IconUserSettings } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconUserSettings'
import { IconPeopleAdd } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPeopleAdd'
import { IconPeopleRemove } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconPeopleRemove'
import { IconClock } from '@central-icons-react/round-outlined-radius-1-stroke-1.5/IconClock'

/**
 * Maps scite icon names to Central React icon components.
 */
const ICON_MAP = {
  // Chat & Messaging
  chat: IconBubbleDots,
  newChat: IconBubblePlus,

  // Table & Data
  table: IconTable,

  // Actions
  trash: IconTrashCan,
  edit: IconPencil,
  share: IconShareOs,
  copy: IconClipboard2,
  download: IconFileDownload,
  search: IconMagnifyingGlass,
  plus: IconPlusLarge,
  minus: IconMinusLarge,
  x: IconCrossMedium,
  check: IconCheckmark1,
  externalLink: IconSquareArrowTopRight,

  // UI Elements
  help: IconCircleQuestionmark,
  info: IconCircleInfo,
  warning: IconExclamationTriangle,
  settings: IconSettingsGear2,
  sparkles: IconSparkle,

  // Navigation
  chevronRight: IconChevronRight,
  chevronLeft: IconChevronLeft,
  chevronDown: IconChevronBottom,
  chevronUp: IconChevronTop,
  minimize: IconMinimize45,
  maximize: IconExpand45,

  // Sidebar
  sidebarCollapsed: IconSidebar,
  sidebarExpanded: IconSidebarLeftArrow,

  // Menus
  moreVertical: IconDotGrid1x3Vertical,
  moreHorizontal: IconDotGrid1x3Horizontal,

  // Misc
  bookmark: IconBookmark,
  bookmarkCheck: IconBookmarkCheck,
  history: IconHistory,
  folder: IconFolder1,
  eye: IconEyeOpen,
  eyeOff: IconEyeSlash,
  tag: IconTag,
  bell: IconBell,
  lightbulb: IconLightBulb,
  searchChecklist: IconSquareChecklistMagnifyingGlass,
  dashboardLayout: IconLayoutDashboard,

  // Arrows
  arrowRight: IconArrowRight,
  arrowLeft: IconArrowLeft,
  arrowUp: IconArrowUp,
  arrowCircleRight: IconArrowRightCircle,
  arrowUpRight: IconArrowUpRight,
  regenerate: IconArrowRotateClockwise,

  // Status
  lock: IconLock,
  checkCircle: IconCircleCheck,
  timesCircle: IconCircleX,
  plusCircle: IconCirclePlus,
  exclamationCircle: IconExclamationCircle,

  // Other
  flag: IconFlag1,
  volumeUp: IconVolumeUp,
  magicWand: IconMagicWand,
  comment: IconBubble2,
  link: IconChainLink1,
  filter: IconFilter1,
  columns: IconColumns3,

  // Feature icons
  demo: IconCursorClick,
  mcp: IconWindowCursor,
  api: IconApiConnection,
  browserExtension: IconBrowserTabs,
  funders: IconCurrencyDollar,
  organizations: IconOrganisation,
  journals: IconBook,
  discoverPatents: IconDeepSearch,
  stayingCurrent: IconCalendarClock,
  researchDiscovery: IconTelescope,
  factChecking: IconBookmarkCheck,
  literatureReviews: IconReadingList,
  patents: IconPageText,

  // Sidebar / Profile
  bio: IconUser,
  metrics: IconTrending1,
  subscription: IconCurrencyDollar,
  accountSettings: IconUserSettings,
  signOut: IconArrowBoxRight,

  // Homepage features
  globalCoverage: IconGlobe2,
  fullTextSearch: IconPageTextSearch,
  smartCitations: IconBookmarkCheck,
  verifiableEvidence: IconShieldCheck,
  trustedByMillions: IconPeople,

  // Context menu
  shareRight: IconArrowShareRight,
  export: IconArrowWallRight,

  // View modes
  layoutGrid: IconLayoutGrid2,
  bulletList: IconBulletList,

  // Status indicators
  zap: IconZap,

  // People & roles
  user: IconUser,
  users: IconPeople,
  userPlus: IconPeopleAdd,
  userRemove: IconPeopleRemove,
  shieldCheck: IconShieldCheck,
  clock: IconClock
}

export default ICON_MAP
